import React from 'react';
import { Button } from 'primereact/button';
import PropTypes from 'prop-types';
import { useMutation } from '@apollo/react-hooks';
import { useIntl } from 'react-intl';
import { REMOVE_ABILITY } from './mutations';
import { growlActionSuccess } from '../../../utils/NotificationUtil';
import { withGrowl } from '../../../components/GrowlNotifications';
import { growlShape } from '../../../components/prop-types';
import messages from './intl-messages';

const DeactivateAbility = ({
  sourceAccountId, targetAccountId, competence, ability, growl, alreadyInUse, fetchData,
}) => {
  const [removeAbility] = useMutation(REMOVE_ABILITY);
  const intl = useIntl();

  return (
    <>
      <Button
        type="button"
        className="p-button-secondary"
        icon="pi pi-lock"
        label={intl.formatMessage(messages.remove)}
        disabled={alreadyInUse}
        onClick={async () => {
          await removeAbility({
            variables: {
              input: {
                sourceAccountId,
                targetAccountId,
                competence,
                ability,
              },
            },
          })
            .then(() => {
              growlActionSuccess(growl, intl.formatMessage(messages.removeAbilitySuccess));
              fetchData();
            })
            .catch(() => {
              growl.show({ severity: 'error', detail: intl.formatMessage(messages.removeAbilityError), sticky: true });
            });
        }}
      />
    </>
  );
};

DeactivateAbility.propTypes = {
  sourceAccountId: PropTypes.number.isRequired,
  targetAccountId: PropTypes.number.isRequired,
  competence: PropTypes.string.isRequired,
  ability: PropTypes.string.isRequired,
  growl: growlShape.isRequired,
  alreadyInUse: PropTypes.bool.isRequired,
  fetchData: PropTypes.func.isRequired,
};

export default withGrowl(DeactivateAbility);
